import * as React from 'react';

/* import Alert from './components/Alert'; */
import Button from '../common/Button';
import Alert from 'src/components/common/Alert';
import Loader from './../common/Loader';

import './UserUpdateInfo.scss';
import UserModel from 'src/model/user.model';
import contactVerificationServiceInstance from 'src/services/contactVerification/contactVerification';
import {
  goToAccount,goToHome
} from 'src/utils/navigation';
import env from 'src/shared/env';
import { red } from 'color-name';
import { deprecate } from 'util';

interface IUserUpdateInfoComponentProps {
  updateUserInfo(email: string, phone: string): void;
  signout(): void;
  pending: boolean;
  error: { hasFailed: boolean; message: string };
  userData: UserModel;
  t: any;
  emailUpdated: any;
  edit: string;
  handleModal:any;
  handleOpenModel:any;
  timerval:any;
  resetTimer:any;
  popupfordirectVerify:any;
}

interface IUserUpdateInfoComponentState {
  email: string;
  phone: string;
  phoneFormate: string;
  enteredphoneOtp: string;
  otpVerifyStatus: string;
  ResendPhoneOtpStatus: string;
  isValid: boolean,
  isVerifyOtp: string,
  phoneAction:string;
  errorAlert: boolean;
  successAlert: boolean;
  openToast: boolean;
  inputRef:any;
  emailAlreadyVerify: boolean;
}

class UserUpdateInfoComponent extends React.Component<
  IUserUpdateInfoComponentProps,
  IUserUpdateInfoComponentState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      email: this.props.userData?.email ? this.props.userData.email : '',
      phone: this.props.userData?.mobileNumber
        ? this.props.popupfordirectVerify ? this.props.userData.mobileNumber:this.props.userData.mobileNumber
        : '',
      enteredphoneOtp:'',
      otpVerifyStatus:'', 
      ResendPhoneOtpStatus: '',
      isValid: this.props.popupfordirectVerify ? true:this.props.edit ==='email' ? true: false,
      isVerifyOtp:'',
      phoneAction:this.props.popupfordirectVerify?'phoneVarificationConfirmation':'',
      errorAlert: false,
      successAlert: false,
      openToast: true,
      phoneFormate:this.props.popupfordirectVerify?this.formatPhoneNumber(this.props.userData.mobileNumber?.replace("+1", '')):'',
      inputRef:React.createRef(),
      emailAlreadyVerify: false
    };
  }

  private handleEmail = (event: any) => {
    this.setState({ email: event.target.value,isValid:true,emailAlreadyVerify:false });
  };

  private handlePhone = (event: any) => {
    // Remove '+1' from the input
    const formattedInput = this.formatPhoneNumber(event.target.value);
    const sanitizedValue = event.target.value.replace(/\D/g, '');
    // Check if the sanitized value is exactly 10 digits
    if (formattedInput.length <= 14) {
      const phoneVal = formattedInput.replace(/[()\s-]/g, '');
      this.setState({ phone: phoneVal, isValid: formattedInput.length === 14,phoneFormate:formattedInput });
    }
    
  };

  private formatPhoneNumber = (value:any) => {
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) { 
      return phoneNumber; 
    }
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };


  private handlePhoneOtpChange = (event: any) => {
    const { value } = event.target;
    const OtpValue = /^\d{0,6}$/.test(value);
    if (OtpValue) {
      this.setState({ enteredphoneOtp: value});
      
    }
    if (value.length === 6 || value.length === 7) {
      this.setState({ isValid: true });
    } else {
      this.setState({ isValid: false });
    }
    
  };

  private updateInfo = () => {
    if (!this.state.phone.includes('+1')) {
      const formattedPhone = this.state.phone;
      this.setState({ phone: formattedPhone });
    }
    this.setState(
      {
        errorAlert: false,
        successAlert: false
      },
      () => {
        if(this.props.edit === 'email') {  
          if(this.props.userData.email === this.state.email && this.props.userData.emailValid) {
            this.setState({emailAlreadyVerify:true, isValid: false});  
          } else {
            this.updatePhoneEmail();
            this.setState({emailAlreadyVerify:false});  
          }
          
        } else if(this.props.edit === 'phone' && this.state.phoneAction ==='') {        
            this.phoneVarificationConfirmation();
        } else if(this.props.edit === 'phone' && this.state.phoneAction ==='phoneVarificationConfirmation' && localStorage.getItem('phoneVerificationLink') !== 'success') {        
           this.updatePhoneEmail();
           this.props.resetTimer();
        } else if(this.props.edit === 'phone' && localStorage.getItem('phoneVerificationLink') ==='success') {
          console.log("test 3");
           this.handleMobileOtpVerification();
           
        }
      }
    );
  };

  private updatePhoneEmail = () => {
    this.props.updateUserInfo(
      this.state.email.toLowerCase(),
      this.state.phone
    );
    if(this.props.edit ==='phone') {
      this.setState({ isValid: false});      
    }
    
        
  }  

  public phoneVarificationConfirmation = () => {
    this.setState({ phoneAction: 'phoneVarificationConfirmation',isValid: true}); 
  }; 

  public phoneUpdateCancel = () => {
    this.setState({ phoneAction: '' });
    localStorage.removeItem('phoneVerificationLink');
    this.setState({ errorAlert: false,successAlert: false,otpVerifyStatus:'',isValid:true});
    
  }; 

  private handleCloseError = () => {
    this.setState({ errorAlert: false });
  };

  private handleEnterToSubmit = (event: any) => {
    if (event.key === 'Enter') {
      this.updateInfo();
    }
  };

  public componentDidMount(): void {
    if (this.state.inputRef.current) {
      this.state.inputRef.current.focus();
    }
  }

  public componentDidUpdate(prevProps: IUserUpdateInfoComponentProps) {
    
    if (this.props.userData !== prevProps.userData) {
      this.setState({
        email: this.props.userData.email,
        phone: this.props.userData.mobileNumber
      });
    }
    if (this.props.emailUpdated !== prevProps.emailUpdated) {
      this.setState({ successAlert: this.props.emailUpdated?.isEmailUpdated });
    }
    if (this.props.error !== prevProps.error) {
      this.setState({ errorAlert: this.props.error.hasFailed });
    }
  }

  public handleCloseSucess = () => {
    this.setState({ successAlert: false });
  };

  public handleMobileOtpVerification = async () => { 
    this.setState({ ResendPhoneOtpStatus: '' });   
    this.setState({ phoneAction: 'handleMobileOtpVerification' });
    const phoneOtpInt = Number(this.state.enteredphoneOtp);
    const currentUrl = window.location.pathname.split('/');
    let languageFromUrl = currentUrl[2];
    if(languageFromUrl === 'fr') {
      languageFromUrl = 'FR';
    } else {
      languageFromUrl = 'EN';
    }
    const region = currentUrl[1];
    const phoneVerifiedStatus = await contactVerificationServiceInstance.validatePhoneOtp(
      localStorage.getItem("activeAccount"),
      phoneOtpInt,
      this.state.phone,
      languageFromUrl,
      region
    );
    console.log("phone number verify status",phoneVerifiedStatus.data);
    if (phoneVerifiedStatus.data) {      
      // setPhoneError("Phone number verified")
      this.setState({ otpVerifyStatus: phoneVerifiedStatus.data,isVerifyOtp:'valid' });    
      setTimeout(() => {
        goToHome();
      }, 300);
    } else {
      this.setState({ otpVerifyStatus: 'failed' });
    }
  }; 
  
  
  public handleResendPhoneOtp = async () => {
    this.setState({ enteredphoneOtp: '',});    
    // setLoading(true);
    // setPhoneError('');
    // setPhoneOtpGenerated(false);
    const currentUrl = window.location.pathname.split('/');
    let languageFromUrl = currentUrl[2];
    if(languageFromUrl === 'fr') {
      languageFromUrl = 'FR';
    } else {
      languageFromUrl = 'EN';
    }
    const region = currentUrl[1];
    const generateOtpResponse = await contactVerificationServiceInstance.generatePhoneOtp(
      localStorage.getItem("activeAccount"),
      this.state.phone,
      languageFromUrl,
      region
    );
    // setLoading(false);
    this.setState({ phoneAction: 'handleResendPhoneOtp',isVerifyOtp:''});
    if (generateOtpResponse.data === 'SUCCESS') {
       this.props.resetTimer();
      // setPhoneError('Verification code sent to phone.');
      // setPhoneOtpGenerated(true);
      this.setState({ ResendPhoneOtpStatus: 'SUCCESS' });
      this.setState({ errorAlert: false });
      return;
    } else {
      if (generateOtpResponse.data === 'OTP_GENERATION_FAILED') {
        // setPhoneError('Failed to send otp. Please try after sometime');
        this.setState({ ResendPhoneOtpStatus: 'failed' });
      } else if (generateOtpResponse.data === 'RETRY_TIMEOUT_NOT_REACHED') {
        this.setState({ ResendPhoneOtpStatus: 'retry' });
        /* setPhoneError(
          'Please try after five minutes. Retry Timeout not reached.'
        ); */
      }
      return;
    }
  };

  private renderHeader = (t: any) => {
    let varificationMessage ='';
    if(this.props.edit === 'email') {
      if(localStorage.getItem('emailVerificationLink') === 'success'){
        varificationMessage = t('accountManagePassword.emailVerifySuccessEmail');
    } else if(localStorage.getItem('emailVerificationLink') === 'failed'){
        varificationMessage =  t('accountManagePassword.emailVerifyFailedEmail');
    } else if(localStorage.getItem('emailVerificationLink') === 'retry'){
        varificationMessage = t('accountManagePassword.emailVerifyRetryEmail');    
    }
    } else {
      // for phone number
       // varificationMessage = t('common.phoneupdatesucess');
      if(this.state.phoneAction === 'phoneOtpResendAction')  {
        // Phone OTP Resend
        if(this.state.ResendPhoneOtpStatus === 'success'){
        varificationMessage = `${this.props.t('accountManagePassword.phoneOtpResendSuccess')}: ${this.state.phone}`;
        } else if(this.state.ResendPhoneOtpStatus === 'failed'){
            varificationMessage =  t('accountManagePassword.phoneOtpResendFailed');
        } else if(this.state.ResendPhoneOtpStatus === 'retry'){
            varificationMessage = t('accountManagePassword.phoneOtpResendRetry');    
        }
      } else {

        if(localStorage.getItem('phoneVerificationLink') === 'success'){
          varificationMessage = `${this.props.t('accountManagePassword.phoneVerifySuccessEmail')}: ${this.state.phoneFormate}`;
          } else if(localStorage.getItem('phoneVerificationLink') === 'failed'){
              varificationMessage =  t('accountManagePassword.phoneVerifyFailedEmail');
          } else if(localStorage.getItem('phoneVerificationLink') === 'retry'){
              varificationMessage = t('accountManagePassword.phoneVerifyRetryEmail');    
          }

      }      

    }
    if (
      this.props.emailUpdated?.isEmailUpdated &&
      this.state.successAlert &&
      !this.props.error.hasFailed
    ) {
      return (
        <>
        {this.props.edit === 'phone' ? (          
        <>
        {(this.state.phoneAction==='handleResendPhoneOtp' && this.state.ResendPhoneOtpStatus === 'SUCCESS')  && (
        <div className="phoneOtpResend">  
          <label className="alert-label">
          {t('common.otpResendMsg')}
        </label>        
        </div>)}
        {(this.state.phoneAction==='handleResendPhoneOtp' && this.state.ResendPhoneOtpStatus === 'failed')  && (
        <div className="phoneOtpFailed">  
          <label className="alert-label">
          {t('common.otpResendFailMsg')}
        </label>        
        </div>)}
        {(this.state.otpVerifyStatus==='' || this.state.otpVerifyStatus === 'failed')  && (
          <>
        <p className="title h1">{t('common.verifyphoneupdateHeading')}</p>
        <div className="rp-user-update-info--form successmmessage">  
         <label className="alert-label">{ varificationMessage } {localStorage.getItem('phoneVerificationLink') === 'success' && (<span className="changePhone"><a href="javascript:void(0)" onClick={this.phoneUpdateCancel} >{t('common.changePhone')}</a></span>)}  
        </label>        
        </div></>)}
        {this.state.otpVerifyStatus === 'failed' && (
        <>
        <div className="rp-user-update-info--form unsuccessmmessage">  
        <label className="alert-label"> {t('common.verifyUnsuccessmsg')}</label></div>
          </>)} 
        </>        
        ):(
          <>
          {varificationMessage ==="" ? <div className="spinner"/> :   
          <div className="rp-user-update-info--form phoneOtpResend">  
          <label className="alert-label">{ varificationMessage }</label></div> } 
           <p className="title h1">{t('common.emailupdate')}</p>
            <span className="subtitle">
              {t('accountManagePassword.verifyWarning', {
                interpolation: { escapeValue: false }
              })}
            </span>
          </>
        )}
        </>
      );
    }
    switch (this.props.error.hasFailed && this.state.errorAlert) {
      default:
      case false:
        return (
          <React.Fragment>
            {this.props.edit === 'email' ? (
            <>
            <p className="title h1">{t('common.emailupdate')}</p>
            <span className={'subtitle'}>
              {t('accountManagePassword.verifyWarning', {
                interpolation: { escapeValue: false }
              })}
            </span>
            </>
      ) : (<>     
          
         {this.state.otpVerifyStatus && this.state.isVerifyOtp === 'valid' && localStorage.getItem('phoneVerificationLink') === 'success' && (
          <>
            <div className="phoneOtpSuccess">  
            <label className="alert-label">
            {t('common.verifySuccessmsg')}
          </label>        
          </div>
		  </>)}
        {(this.state.otpVerifyStatus === 'failed' || this.state.ResendPhoneOtpStatus === 'SUCCESS') && localStorage.getItem('phoneVerificationLink') === 'success' && (
          <>
          {this.state.ResendPhoneOtpStatus === '' ? (
            <div className="phoneOtpFailed">  
            <label className="alert-label">
            {t('common.verifyUnsuccessmsg')}
          </label>        
          </div>
          ):(
            <div className="phoneOtpResend">  
            <label className="alert-label">
            {t('common.otpResendMsg')}
          </label>        
          </div>
          )}
          

          
          </>
        )}     
			  {this.props.edit === 'phone' && this.state.phoneAction === '' && (<p className="title h1">{t('common.phoneupdate')}</p>)}			  
			  {this.props.edit === 'phone' && this.state.phoneAction === 'phoneVarificationConfirmation' && ( <p className="title h1">{t('common.phoneHeadingVeficationConfirm')}</p>)}			  
			  {this.props.edit === 'phone' && localStorage.getItem('phoneVerificationLink') === 'success' && (this.state.otpVerifyStatus ==='' || this.state.otpVerifyStatus ==='failed')  &&  (
        <><p className="title h1">{t('common.verifyphoneupdateHeading')}</p>
        <div className="rp-user-update-info--form successmmessage">  
        <label className="alert-label">{ varificationMessage } {(localStorage.getItem('phoneVerificationLink') === 'success' || this.state.otpVerifyStatus === 'failed') && (<span className="changePhone"><a href="javascript:void(0)" onClick={this.phoneUpdateCancel} >{t('common.changePhone')}</a></span>)}  
       </label>        
       </div></>)}
        
       </>)}
          </React.Fragment>
        );
      case true:
        const message = this.props.error.message.split('-');
        let targetMessage = '';
        if (message.length === 2) {
          targetMessage = `\u2022 ${this.getMessage(message[0])} \r\n
          \u2022 ${this.getMessage(message[1])}`;
        } else {
          targetMessage = this.getMessage(message[0]);
        }
        return (
          <Alert
            type="error"
            styleClass="rp-user-update-info--error-alert pre-line-white-space"
            icon={'rpds-error'}
            handleCloseAlert={this.handleCloseError}
            message={targetMessage}
          />
        );
    }
  };

  private getMessage = (message: string): string => {
    const { t } = this.props;
    if (message?.toLowerCase()?.includes('phone')) {
      return t('accountManagePassword.invalidPhoneNumber');
    } else if (message?.toLowerCase()?.includes('email')) {
      return t('accountManagePassword.invalidEmail');
    }
    return message;
  };

  public render() {
    // cancel button action
    let cancelButtonAction = this.props.handleModal;
    if(this.props.edit ==='phone' && this.state.phoneAction ==='phoneVarificationConfirmation' && this.props.popupfordirectVerify ==='') {
       cancelButtonAction = this.phoneUpdateCancel;
    } else if(this.props.edit ==='phone' && this.state.phoneAction ==='phoneVarificationConfirmation' && this.props.popupfordirectVerify) {
      cancelButtonAction = this.props.handleModal;
   }  
    const { t } = this.props;

    const CancelbuttonLabel = t('common.cancelPhoneUpdate');

    // update button lebel
    let buttonLabel = t('common.update');
    if(this.props.edit ==='phone' && this.state.phoneAction ==='phoneVarificationConfirmation' && localStorage.getItem('phoneVerificationLink') !=='success') {
      buttonLabel = t('common.updateOk');
    } else if(this.props.edit ==='phone' && localStorage.getItem('phoneVerificationLink') ==='success' || this.state.otpVerifyStatus ==='failed' ) {
      buttonLabel =t('common.verifyOtp');
    }

    return (
      <div className="rp-user-update-info--container">
        {this.props.pending ? <Loader /> : null}
        {/* Component container ^ */}
        {/* Component header v*/}
        <div className="rp-user-update-info--header">
          {this.renderHeader(t)}
        </div>
        {/* Component content */}
        <div className="rp-user-update-info--content">
          <form className="rp-user-update-info--form">
          {this.props.edit === 'email' && (
              <>
                <label className="form--label h4" htmlFor="email" style={{ textAlign: 'left' }}>
                  {t('common.email')}:
                </label>
                <input
                ref={this.state.inputRef}
                  className="form--text-input"
                  type="text"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleEmail}
                  tabIndex={1}
                />
              </>
            )}
            {this.state.emailAlreadyVerify && (
              <div className="already-verified-message">{t('common.emailAlreadyVerified')}</div>
            )}
            {/* <a className="form--link" href="javascript:void(0)" onClick={goToForgotUser}>
              {t("login.forgotUserId")}
            </a> */}
            {this.props.edit === 'phone' && localStorage.getItem('phoneVerificationLink') !== 'success' && (
              <>
              {this.state.phoneAction === 'phoneVarificationConfirmation' && (
              <div className="confirmmessage">{t('common.phoneupdateConfirm')} 
                <div className="countryphone">{env.REACT_APP_BASE_ENVIRONMENT === 'US' ?(<>
              <img src="https://reliableparts.net/wp-content/uploads/2019/02/USA.png" className="countryFlag" alt="Logo" />
              <span className="countryCodeValOld">US+1</span></>
                ):(<>
                  <img src="https://reliableparts.net/wp-content/uploads/2019/02/CANADA.png" className="countryFlag" alt="Logo" />
                  <span className="countryCodeValOld">CA+1</span></>
                )}<span className="verifyphoneNumber">{this.state.phoneFormate.startsWith('+1') ? this.state.phoneFormate.substring(2) : this.state.phoneFormate}</span>  </div>
              <div className="messageRates">* {t('common.phoneupdateRates')}</div>
              </div>)}

              {this.state.phoneAction === '' && (<>
                {this.props.userData.mobileNumber && (<><div className="oldphonecontainer">
              <div className="oldphonetext">{t('common.phoneupdateOld')}</div>
              <div className="oldphonecountry">{env.REACT_APP_BASE_ENVIRONMENT === 'US' ?(<>
              <img src="https://reliableparts.net/wp-content/uploads/2019/02/USA.png" className="countryFlag" alt="Logo" />
              <span className="countryCodeValOld">US+1</span></>
                ):(<>
                  <img src="https://reliableparts.net/wp-content/uploads/2019/02/CANADA.png" className="countryFlag" alt="Logo" />
                  <span className="countryCodeValOld">CA+1</span></>
                )} <span className="oldphone">{this.props.userData.mobileNumber.startsWith('+1') ? this.formatPhoneNumber(this.props.userData.mobileNumber.substring(2)) : this.formatPhoneNumber(this.props.userData.mobileNumber)}</span></div>
              </div></>)}   
              <label className="oldphonetext" htmlFor="phone" style={{ textAlign: 'left' }}>
                {t('common.phone')}
              </label>
              <div className="phone-input-container countrycode">
              {env.REACT_APP_BASE_ENVIRONMENT === 'US' ?(<>
              <img src="https://reliableparts.net/wp-content/uploads/2019/02/USA.png" className="countryFlagSecond"  alt="Logo" />
              <span className="countryCodeVal">US+1</span></>
                ):(<>
                  <img src="https://reliableparts.net/wp-content/uploads/2019/02/CANADA.png"  className="countryFlagSecond"  alt="Logo" />
                  <span className="countryCodeVal">CA+1</span></>
                )}
             <input
                ref={this.state.inputRef}
                className="phone-form--text-input"
                type="phone"
                value={this.state.phoneFormate.startsWith('+1') ? this.state.phoneFormate.substring(2) : this.state.phoneFormate}
                onChange={this.handlePhone}
                onKeyPress={this.handleEnterToSubmit}
                tabIndex={2}
              />               
            </div></>)}              
              </>
            )}

              {this.props.edit === 'phone' &&
                  localStorage.getItem('phoneVerificationLink') === 'success' &&  (this.state.otpVerifyStatus === '' || this.state.otpVerifyStatus=== 'failed') &&(
                <>
                <span className="phoneOtp" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  <div style={{ textAlign: 'left' }}>{t('common.phoneOtp')}:{' '}</div>

                  <div className="resendOtp" style={{ textAlign: 'right' }}>
                  {this.props.timerval > 1 && (
                    t('common.phoneResendOtpIn')+
                    ' ('+this.props.timerval+')')}
                    {this.props.timerval <= 1 && (
                      <a href="javascript:void(0)" onClick={this.handleResendPhoneOtp}>{t('common.phoneResendOtp')}</a>

                    )}
                  
                </div>
                </span>
                <input 
                type="phone"
                  className="form--text-input"
                  value={this.state.enteredphoneOtp}
                  onChange={this.handlePhoneOtpChange}
                  onKeyPress={this.handleEnterToSubmit}
                  tabIndex={2}
                />                 
              </>              
            )}
            {this.props.edit === 'phone' &&
                  localStorage.getItem('phoneVerificationLink') !== 'success' && this.state.phoneAction !=='phoneVarificationConfirmation' && (               
                <div className="privacy-security-content">{t('common.phoneupdateTerms')} 
            </div>)}
            <div className="form--rp-user-update-info">
            {this.state.otpVerifyStatus && this.state.isVerifyOtp === 'valid' && localStorage.getItem('phoneVerificationLink') === 'success' ? '' : (
              <span className="primary-button form--update-button cancelButton" onClick={cancelButtonAction}>{CancelbuttonLabel}</span>)}
             
              {(!this.state.otpVerifyStatus || this.state.otpVerifyStatus === 'failed') && (<>
                
              {this.props.edit ==='phone' && this.state.phoneAction ==='phoneVarificationConfirmation' && localStorage.getItem('phoneVerificationLink') !=='success' ? 
              <span className="primary-button form--update-button okButton" onClick={this.updateInfo}>{buttonLabel}</span> :
              <span className="phoneupdateButton">
                <Button
                buttonClass="primary-button form--update-button"
                label={buttonLabel}
                height="48px"
                width="100%"                
                action={this.updateInfo}
                disabled={!this.state.email && !this.state.phone ||
                  this.state.successAlert &&
                  !this.props.error.hasFailed && localStorage.getItem('phoneVerificationLink') !=='success' || !this.state.isValid}
                /></span>}</>)}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default UserUpdateInfoComponent;
